export default __webpack_public_path__ + "static/media/icon-warning-filled.0747849c.svg";